import { useCallback } from 'react';
import { bridge } from '../../../bridge';
import { appendParams, finalizeUrl, getDefaultDeeplink } from '../../utils';

export const useMoveToFragmentScreens = () => {
  return useCallback(
    (screenName: string, extraParams?: Record<string, unknown>) => {
      // bridge.openDeeplink(`ably://react/App`)
      const getDeeplink = () => {
        const url = getDefaultDeeplink();
        appendParams(url, 'screen', 'FragmentScreens');
        return url;
      };
      const extras = {
        // sno,
        // ...(loggingAnalytics ? loggingAnalytics : {}),
        // ...(firstPageRendering ? firstPageRendering : {}),
        // ...(couponSno ? { coupon_sno: couponSno } : {}),
        screen_name: screenName,
        ...(extraParams ? extraParams : {}),
      };
      const goodsDetailDeeplink = getDeeplink();
      appendParams(goodsDetailDeeplink, 'extras', JSON.stringify(extras));

      return bridge.openDeeplink(finalizeUrl(goodsDetailDeeplink), {
        webCallback: async () => {
          const url = new URL(`${location.origin}/screens/fragment`);
          const queryString = url.searchParams;
          queryString.set('extras', JSON.stringify(extras));
          location.href = `${location.origin}/screens/fragment?${queryString}`;
        },
      });
    },
    [],
  );
};
